import React, {FC} from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {BackButton} from "../buttons/BackButton";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {Locale} from "../../locales/Locale";
import {InfoMessage} from "./InfoMessage";

interface NoDataProps {
    messageLocaId: IdlocaGeneric;
    redirectButtonLocaId: IdlocaGeneric;
    redirectUrl: string;
}

export const NoData: FC<NoDataProps> = ({
    messageLocaId,
    redirectButtonLocaId,
    redirectUrl,
}) => {
    const navigate = useNavigate();
    return (
        <Card
            elevation={3}
            sx={{
                borderRadius: "8px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "16px",
                marginTop: "16px",
                backgroundColor: theme => theme.palette.card.background,
            }}
        >
            <CardContent sx={{display: "flex", alignItems: "center", width: "100%"}}>
                <Box sx={{display: "flex", justifyContent: "flex-start", width: "100%"}}>
                    <BackButton/>
                    <Button
                        variant="outlined"
                        sx={{
                            marginLeft: "16px",
                            backgroundColor: theme => theme.palette.button.primary,
                            color: theme => theme.palette.button.text,
                            "&:hover": {
                                backgroundColor: theme => theme.palette.button.hover,
                            },
                        }}
                        onClick={() => navigate(redirectUrl)}
                    >
                        <Locale localeId={redirectButtonLocaId}/>
                    </Button>
                </Box>
            </CardContent>
            <Typography sx={{textAlign: "center", marginTop: "16px"}}>
                <InfoMessage messageLocaId={messageLocaId} type="info"/>
            </Typography>
        </Card>
    );
};
